import { render } from "./CoursesDetails.vue?vue&type=template&id=09e42dd8&scoped=true&ts=true"
import script from "./CoursesDetails.vue?vue&type=script&lang=ts"
export * from "./CoursesDetails.vue?vue&type=script&lang=ts"

import "./CoursesDetails.vue?vue&type=style&index=0&id=09e42dd8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09e42dd8"]])

export default __exports__